import React, { Component } from 'react'

export default class EmptyEditor extends Component {
    render() {
        return (
            <nav className="sidebar sidebar-offcanvas bg-white" id="sidebar">
                <div className="row h-100 d-flex justify-content-center align-items-center">
                    Click to Edit
                </div>
            </nav>
        )
    }
}
